import {
  get,
  post,
  error,
  filterAsyncRouter
} from '@/api/common.js'


function fun1(path, params, that) {
  get(path, params).then(function(Response) {
    that.listArr = Response.data;
    window.localStorage.setItem("myRouter", JSON.stringify(that.listArr))
    that.$router.addRoutes(filterAsyncRouter(that.listArr))
  }, function(Response) {
    error(Response);
  });
}

function getAllCarousel(path, that) {
  get(path).then(function(Response) {
    that.$store.state.items = Response.data;
  }, function(Response) {
    error(Response);
  });
}

function getAllCarousel2(path, that) {
  get(path).then(function(Response) {
    that.items = Response.data;
    that.isReady(that);
  }, function(Response) {
    error(Response);
  });
}

export {
  fun1,
  getAllCarousel,
  getAllCarousel2,
}



// WEBPACK FOOTER //
// ./src/api/carousel.js